export default __webpack_public_path__ + "static/media/1-2-1.e609d2e3.webp";